import {IStore} from "modules/types/store";

export const isTutorialOpen = (state: IStore) => state.tutorial;
